module.exports = __webpack_public_path__ + "static/media/google.9fa9f6e1.svg";